// @flow
/**
 * Created by Mike Chung on 3/2/18.
 */
import FairConfig from "../model/fair/FairConfig";
import * as _ from "lodash";
import config from "../config/config";

export async function loadFairConfigs(auth: string): Promise<Array<FairConfig>> {

    try {
        let response = await fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/configs`, {
            headers: {
                "content-type": "text/plain",
                "Authorization": `Bearer ${auth}`
            }
        });

        if (response.status > 200) {

            let error = new Error(response.statusText);
            // $FlowFixMe
            error.response = response;
            throw error
        } else {
            let configs = await response.json();
            return _.map(configs, (config) => {
                return Object.assign(config, {fairNames: config.fairName});
            });
        }

    } catch (e) {
        throw e;
    }

}


// WEBPACK FOOTER //
// ./src/dao/fairConfigDao.js